export default "__VITE_ASSET__CHW5v0Ys__"